import { render, staticRenderFns } from "./business.vue?vue&type=template&id=1d20476e&scoped=true"
import script from "./business.vue?vue&type=script&lang=js"
export * from "./business.vue?vue&type=script&lang=js"
import style0 from "./business.vue?vue&type=style&index=0&id=1d20476e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20476e",
  null
  
)

export default component.exports